// extracted by mini-css-extract-plugin
export var carouselMedia__image = "carousel-media-module--carousel-media__image--aba3a";
export var carouselMedia__video = "carousel-media-module--carousel-media__video--de7ac";
export var mt0 = "carousel-media-module--mt-0--99ac9";
export var mt1 = "carousel-media-module--mt-1--46605";
export var mt2 = "carousel-media-module--mt-2--14ba6";
export var mt3 = "carousel-media-module--mt-3--61a65";
export var mt4 = "carousel-media-module--mt-4--d0b24";
export var mt5 = "carousel-media-module--mt-5--64bea";
export var mt6 = "carousel-media-module--mt-6--1be6b";